<div class="dropdown">
    <button class="btn btn-icon btn-sm" [class]="colorClass()" type="button" title="Theme" data-bs-toggle="dropdown">
        <fa-duotone-icon [icon]="(isDarkThemeActive$ | async) ? 'moon' : 'sun-bright'" class="theme-icon bs-emphasis-color" size="xl" secondaryOpacity="0.9"/>
    </button>
    <div class="dropdown-menu dropdown-menu-end theme-dropdown">
        <div class="dropdown-header">
            <span class="fw-bold">Theme Mode</span>
        </div>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item theme-option" data-theme="light"
            (click)="setTheme('light')" [class.active]="(currentTheme$ | async) === 'light'">
            <fa-duotone-icon icon="sun-bright" secondaryOpacity="0.9" class="me-2"/>Light
        </a>
        <a class="dropdown-item theme-option" data-theme="dark"
            (click)="setTheme('dark')" [class.active]="(currentTheme$ | async) === 'dark'">
            <fa-duotone-icon icon="moon" secondaryOpacity="0.9" class="me-2"/>Dark
        </a>
        <a class="dropdown-item theme-option" data-theme="system"
            (click)="setTheme('system')" [class.active]="(currentTheme$ | async) === 'system'">
            <fa-duotone-icon icon="desktop" class="me-2"/>System
        </a>
</div>